import React, { useEffect, useState } from 'react';
import {
  Button,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  AlertDialogCloseButton,
} from '@chakra-ui/react';
import { useForm, Controller } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import InputController from 'components/Form/InputController';
import { ModalType } from 'constants/common';
import { toast } from 'components/Toast';
import { useCreateScriptMutation, useUpdateScriptMutation } from 'services/category';
import { ScriptFormValidate } from 'utils/validation';
import { yupResolver } from '@hookform/resolvers/yup';
import isEmpty from 'lodash/isEmpty';

const CreateCategoryModal = ({ isOpen, categorysDetail, onClose, refetch }) => {
  const params = useParams();
  const { id: categoryId } = params || {};
  const cancelRef = React.useRef();
  const createScriptMutation = useCreateScriptMutation();
  const updateScriptMutation = useUpdateScriptMutation();
  const { control, handleSubmit, reset, setValue } = useForm({
    resolver: yupResolver(ScriptFormValidate),
    defaultValues: {
      url: '',
    },
  });

  useEffect(() => {
    if (categorysDetail) {
      reset({ url: categorysDetail.url, id: categorysDetail.id });
    }
  }, [categorysDetail]);

  const handleSuccess = () => {
    toast.showMessageSuccess(`${categorysDetail ? 'Cập nhật' : 'Tạo'} Script thành công`);
    refetch?.();
    onClose(ModalType.Add);
  };
  const handleError = error => {
    toast.showMessageError(
      error?.response?.data?.errors?.[0]?.msg ||
        error?.response?.data?.msg ||
        `${categorysDetail ? 'Cập nhật' : 'Tạo'} Script thành công`
    );
  };
  const onSubmit = async values => {
    if (!isEmpty(categorysDetail)) {
      updateScriptMutation.mutate(
        { url: values?.url, urlId: categorysDetail?._id },
        {
          onSuccess: () => {
            handleSuccess();
          },
          onError: error => handleError(error),
        }
      );
    } else {
      createScriptMutation.mutate(
        { ...values },
        {
          onSuccess: () => handleSuccess(),
          onError: error => handleError(error),
        }
      );
    }
  };
  return (
    <>
      <AlertDialog
        motionPreset="slideInBottom"
        leastDestructiveRef={cancelRef}
        onClose={() => {
          onClose(ModalType.Add);
        }}
        isOpen={isOpen}
        isCentered
      >
        <AlertDialogOverlay />
        <AlertDialogContent maxW={'600px'} maxH={'400px'}>
          <AlertDialogHeader textTransform="uppercase">{categorysDetail ? 'Cập nhật' : 'Tạo'} Script</AlertDialogHeader>
          <AlertDialogCloseButton />
          <AlertDialogBody>
            <InputController control={control} name="url" label="Đường dẫn" type="textarea" />
          </AlertDialogBody>
          <AlertDialogFooter>
            <Button
              ref={cancelRef}
              onClick={() => {
                onClose(ModalType.Add);
              }}
            >
              Hủy
            </Button>
            <Button
              colorScheme="blue"
              ml={3}
              isLoading={createScriptMutation.isPending}
              onClick={handleSubmit(onSubmit)}
            >
              {categorysDetail ? 'Cập nhập' : 'Tạo'}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};

export default CreateCategoryModal;
